import { MODULE_NAME } from "./configureStore";
export const selectComplaints = (state) => state[MODULE_NAME].complaints;
export const selectComplaint = (state) => state[MODULE_NAME].complaint;
export const selectActivities = (state) => state[MODULE_NAME].activities;
export const selectRoles = (state) => state[MODULE_NAME].roles;
export const selectCaseRoles = (state) => {
    if (state[MODULE_NAME].roles.data && state[MODULE_NAME].roles.data.length > 0) {
        return state[MODULE_NAME].roles.data.filter(x => !x.isDenial);
    }
    else {
        return [];
    }
};
export const selectUrlSearch = (state) => state[MODULE_NAME].urlSearch;
export const analyticsSelector = (state) => state[MODULE_NAME].analytics;
export const teamAnalyticsSelector = (state) => state[MODULE_NAME].teamAnalytics;
export const selectUserRoles = (state) => {
    var _a, _b;
    const denials = state[MODULE_NAME].roles.data.filter(x => x.isDenial);
    const userRoles = (_b = (_a = state[MODULE_NAME].roles) === null || _a === void 0 ? void 0 : _a.userRoles) !== null && _b !== void 0 ? _b : [];
    const aggregatedUserRoles = userRoles.map(x => {
        const matchingDenial = denials.filter(d => d.userId.toLowerCase() === x.upn.toLowerCase());
        const isDenied = matchingDenial.length > 0;
        return Object.assign(Object.assign({}, x), { isDenied, denialId: isDenied ? matchingDenial[0].caseRoleId : null });
    });
    return aggregatedUserRoles;
};
export const userSelector = (state) => { var _a; return (_a = state.auth) === null || _a === void 0 ? void 0 : _a.user; };
